type Cell = { month_year: string; value: number | string | null };
type Row = { field: string; label: string; months: Cell[] };

const MeterReadDetailsTableRunningTotalCell = ({
  record,
  start = null,
  stop = null,
  fieldsWithRunningTotals,
  styles,
}: {
  record: Row;
  start?: Date | null;
  stop?: Date | null;
  fieldsWithRunningTotals?: any[];
  styles: any;
}) => {
  // contractStart/End come from ISO strings parsed with `new Date("YYYY-MM-DD")` (UTC midnight),
  // which shifts one month back in negative-UTC-offset timezones when using .getMonth().
  // Use UTC accessors to read the correct month, then build local-time dates for comparison.
  const startDate = start ? new Date(start.getUTCFullYear(), start.getUTCMonth(), 1) : null;
  const stopDate = stop ? new Date(stop.getUTCFullYear(), stop.getUTCMonth() + 1, 0) : null;

  const shouldShow =
    fieldsWithRunningTotals?.includes((record as any).field) ||
    fieldsWithRunningTotals?.includes((record as any).label);

  if (!shouldShow) return <strong className={styles.runningTotalNA}>NA</strong>;

  const months = record.months.filter((item) => {
    if (!item?.month_year) return false;
    const [year, month] = item.month_year.split('-').map(Number);
    // Create date at start of the month for comparison
    const d = new Date(year, month - 1, 1);
    // Filter: keep only months within the date range
    if (startDate && d < startDate) return false;
    if (stopDate && d > stopDate) return false;
    return true;
  });

  const total = months.reduce((sum, m) => {
    const n = Number((m?.value as any) ?? 0);
    return sum + (Number.isFinite(n) ? n : 0);
  }, 0);

  const isKwh = /kwh/i.test((record as any).label || '');
  const formattedTotal = isKwh ? Math.round(total).toLocaleString() : total.toFixed(2);

  return total === 0 ? (
    <strong className={styles.runningTotalNA}>NA</strong>
  ) : (
    <strong className={styles.runningTotal}>{formattedTotal}</strong>
  );
};

export default MeterReadDetailsTableRunningTotalCell;
